import * as types from "./actionTypes";
import axios from "axios";

export const getDailyUserLectures = (batchId, sectionId) => (dispatch) => {
    console.log("get daily", batchId, sectionId);
    dispatch({ type: types.GET_DAILY_LECTURE_REQUEST });
    return fetch(
        `http://54.206.125.24:8888/api/lecture/schedule/${batchId}/${sectionId}`
    )
        .then((r) => r.json())
        .then((data) => {
            console.log("data", data);
            dispatch({
                type: types.GET_DAILY_LECTURE_SUCCESS,
                payload: data,
            });
        })
        .catch((err) => {
            console.log("err", err);
            dispatch({ type: types.GET_DAILY_LECTURE_FAILURE, payload: err });
        });
};

export const setLecture = (lectureDate, token) => (dispatch) => {
    dispatch({
        type: types.SET_LECTURE_REQUEST,
        payload: true,
    })
    return axios.post("http://54.206.125.24:8888/api/lecture/addLecture", lectureDate, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
        .then((res) => {
            console.log(res);
            dispatch({
                type: types.SET_LECTURE_SUCCESS,
                payload: res.data,
            });
            return res.data;
        })
        .catch((err) => {
            console.log(err.message);
            dispatch({
                type: types.SET_LECTURE_FAILURE,
                payload: true,
            });
        });
};

export const searchLectures = (batchId, sectionId, token, payload) => (dispatch) => {
    console.log("ewrrtre", batchId, sectionId, token, payload);
    dispatch({ type: types.GET_SEARCH_LECTURES_REQUEST });
    return axios({
        method: "post",
        url: `api/lecture/searchByUser/${batchId}/${sectionId}`,
        baseURL: "http://54.206.125.24:8888/",
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: JSON.stringify(payload),
    })
        .then((r) => {
            console.log("search", r.data);
            dispatch({ type: types.GET_SEARCH_LECTURES_SUCCESS, payload: r.data });
        })
        .catch((err) => {
            console.log("search err", err);
            dispatch({ type: types.GET_SEARCH_LECTURES_FAILURE, payload: err });
        })
};

export const getLecture = (token) => (dispatch) => {
    dispatch({
        type: types.GET_ADMIN_LECTURE_REQUEST,
        payload: true,
    })
    axios.get("http://54.206.125.24:8888/api/lecture/lectures?pageNumber=0", {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
        .then((res) => {
            console.log(res);
            dispatch({
                type: types.GET_ADMIN_LECTURE_SUCCESS,
                payload: res.data,
            });
        })
        .catch((err) => {
            console.log(err.message);
            dispatch({
                type: types.GET_ADMIN_LECTURE_FAILURE,
                payload: true,
            })
        })
};

export const editLecture = (lectureDate, token, lectureId) => (dispatch) => {
    dispatch({
        type: types.EDIT_LECTURE_REQUEST,
        payload: true,
    });
    return axios.put(`http://54.206.125.24:8888/api/lecture/lectures/${lectureId}`, lectureDate, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
        .then((res) => {
            console.log(res);
            dispatch({
                type: types.EDIT_LECTURE_SUCCESS,
                payload: res.data,
            });
            return res.data;
        })
        .catch((err) => {
            console.log(err.message);
            dispatch({
                type: types.EDIT_LECTURE_FAILURE,
                payload: true,
            });
        });
};

export const setBulkLecture = (csvFile, token) => (dispatch) => {
    dispatch({
        type: types.SET_BULK_LECTURE_REQUEST,
        payload: true,
    });
    return axios.post("http://54.206.125.24:8888/api/lecture/upload", csvFile, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
        },
    })
        .then((res) => {
            console.log(res);
            dispatch({
                type: types.SET_BULK_LECTURE_SUCCESS,
                payload: res.data,
            });
            return types.SET_BULK_LECTURE_SUCCESS;
        })
        .catch((err) => {
            console.log(err.message);
            dispatch({
                type: types.SET_BULK_LECTURE_FAILURE,
                payload: true,
            });
        })
};

export const searchLectureAdmin = (searchData, token) => (dispatch) => {
    dispatch({
        type: types.POST_SEARCH_ADMIN_LECTURE_REQUEST,
        payload: true,
    });
    return axios.post("http://54.206.125.24:8888/api/lecture/searchByAdmin", searchData, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
        .then((res) => {
            console.log(res);
            dispatch({
                type: types.POST_SEARCH_ADMIN_LECTURE_SUCCESS,
                payload: res.data,
            });
            return res.data;
        })
        .catch((err) => {
            console.log(err.message);
            dispatch({
                type: types.POST_SEARCH_ADMIN_LECTURE_FAILURE,
                payload: true,
            })
        })
};

export const getAllLectures = (batchId, sectionId, token) => (dispatch) => {
    console.log("tokens", token)
    dispatch({ type: types.GET_ALL_LECTURE_REQUEST });
    return axios.get(`http://54.206.125.24:8888/api/lecture/${batchId}/${sectionId}`, {
        headers: {
            Authorization: `Bearer ${token}`
        },
    })
        .then((res) => {
            console.log("all lectures", res.data);
            dispatch({ type: types.GET_ALL_LECTURE_SUCCESS, payload: res.data });
        })
        .catch((err) => {
            console.log("err", err);
            dispatch({ type: types.GET_ALL_LECTURE_FAILURE, payload: err });
        });
};
